module.exports = __webpack_public_path__ + "img/card-gold-member.b15c22b7.png";